enum HelpPageEnum {
	SEND_MESSAGE = 'Mande sua mensagem',
}

enum SendMessagePageEnum {
	SEND_MESSAGE_BUTTON = 'Enviar mensagem',
	SEND_MESSAGE_SUCCESSFULLY = 'Sua mensagem foi enviada com sucesso',
	SEND_MESSAGE_TIMEOUT = 'Aguarde para enviar nova mensagem',
}

export {HelpPageEnum, SendMessagePageEnum};
